import React from 'react';
import { Calendar, Zap } from 'lucide-react';
export const MegapackExtra = () => {
  return <section className="py-20 bg-brand-900 text-white" data-id="element-166">
      <div className="max-w-5xl mx-auto px-4" data-id="element-167">
        <div className="text-center mb-16" data-id="element-168">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-169">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-xl text-brand-200" data-id="element-170">
            Por solo $9.000 más, tenés el sistema completo para todo el año.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-171">
          <div className="bg-brand-800/50 p-8 rounded-3xl border border-brand-700" data-id="element-172">
            <div className="w-14 h-14 bg-brand-700 rounded-2xl flex items-center justify-center mb-6" data-id="element-173">
              <Calendar className="w-7 h-7 text-brand-200" data-id="element-174" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-175">
              📅 Élite 1 — PLANIFICACIÓN ANUAL 360
            </h3>
            <p className="text-brand-100 leading-relaxed" data-id="element-176">
              Tu calendario maestro de 40 semanas resuelto. Qué tomo abrir cada
              lunes. Qué objetivo lograr en mayo, agosto y noviembre. El año
              entero planificado antes de empezar. No llegás más al club
              preguntándote qué dar hoy.
            </p>
          </div>

          <div className="bg-brand-800/50 p-8 rounded-3xl border border-brand-700" data-id="element-177">
            <div className="w-14 h-14 bg-brand-700 rounded-2xl flex items-center justify-center mb-6" data-id="element-178">
              <Zap className="w-7 h-7 text-amber-400" data-id="element-179" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-180">
              🛼 Élite 2 — EL ACELERADOR AXEL
            </h3>
            <p className="text-brand-100 leading-relaxed" data-id="element-181">
              La clínica técnica definitiva del salto más importante del patín
              artístico. Los 5 ejercicios invisibles, la psicología del vuelo,
              el análisis de video con el celular y el protocolo de 8 semanas
              para lograr el Axel con niños y con adultos. El Axel de tu alumno
              es el diploma que nadie te puede quitar.
            </p>
          </div>
        </div>
      </div>
    </section>;
};